import React, { Component } from "react";

//Default import
import Const from "../config/const";
import HeaderHOC from "../hoc/HeaderHOC";
//Component Imports
import LanguageSelector from "./laguage";
import { Link } from "react-router-dom";
import MenuComponent from "./menu";
import PropTypes from "prop-types";
//Image imports
import logoHeaderImage from "../img/logoInvert.png";

class HeaderComponent extends Component {
  constructor() {
    super();
    this.state = {
      logoWidth: 0,
      languageWidth: 0,
    };
  }

  render() {
    const {
      menuList,
      colSize,
      background,
      logoOrder,
      classOver,
      screenWidth,
    } = this.props;

    return (
      <header style={background && screenWidth >= 992 ? background : {}}>
        <div className="container h-100">
          <div
            className={`row h-100 justify-content-end ${
              screenWidth >= 992 ? "align-items-center" : "align-items-start"
            } ${screenWidth >= 992 ? classOver : ""}`}
          >
            <div
              className={`col-lg-${
                colSize ? "6 offset-1" : "4"
              } d-none d-md-none d-lg-block d-xl-block`}
            ></div>
            <div
              className={`col-6 col-md-6 col-lg-${colSize ? "2" : "4"} ${
                screenWidth >= 992
                  ? "justify-content-center"
                  : "justify-content-start"
              } logo h-100 d-flex  align-items-end ${logoOrder || ""}`}
            >
              <Link to={"/"}>
                <img
                  className="img-fluid"
                  src={logoHeaderImage}
                  alt={Const.defaults.title}
                />
              </Link>
            </div>
            <div
              className={`col-6 col-md-6 col-lg-${
                colSize ? "3" : "4"
              } right-content d-flex flex-row justify-content-end align-items-center`}
            >
              <LanguageSelector />
              <MenuComponent menuList={menuList} />
            </div>
          </div>
        </div>
      </header>
    );
  }
}

HeaderComponent.propType = {
  menuList: PropTypes.array.isRequired,
  colSize: PropTypes.bool,
  background: PropTypes.object,
  logoOrder: PropTypes.string,
  classOver: PropTypes.string,
};

export default HeaderHOC(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/header.js